import * as React from "react";
import SectionComponent from "components/common/Section/SectionComponent";
import TeamsCollection from "collections/components/TeamCollections";
import { COLLECTIONS_ENABLED } from "collections/constants";
const CollectionsSection = ({ team }) => {
  if (COLLECTIONS_ENABLED)
    return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Collections" }, /* @__PURE__ */ React.createElement(TeamsCollection, { teamId: team.id }));
  return null;
};
export default CollectionsSection;
